import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, variant = "pink", ...props }, ref) => {
  const isPink = variant === "pink";
  
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn("relative flex w-full touch-none select-none items-center", className)}
      {...props}>
      <SliderPrimitive.Track
        className={cn(
          "relative h-2 w-full grow overflow-hidden rounded-full",
          isPink ? "bg-[#FFE4EC]" : "bg-[#E0F2FE]"
        )}>
        <SliderPrimitive.Range 
          className={cn(
            "absolute h-full",
            isPink 
              ? "bg-gradient-to-r from-[#FF69B4] to-[#E05297]" 
              : "bg-gradient-to-r from-[#87CEEB] to-[#5BA3C6]"
          )} 
        />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={cn(
          "block h-6 w-6 rounded-full border-[3px] bg-white shadow-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 cursor-grab active:cursor-grabbing",
          isPink 
            ? "border-[#FF69B4] shadow-pink-200 focus-visible:ring-[#FF69B4]" 
            : "border-[#87CEEB] shadow-blue-200 focus-visible:ring-[#87CEEB]"
        )} 
      />
    </SliderPrimitive.Root>
  );
});
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
